import React, { useState } from "react";
import { MdLogout, MdOutlineAdd ,MdReviews  } from "react-icons/md";
import { FaHome, FaAddressCard } from "react-icons/fa";
import { logout } from "../store/reducers/authReducer";
import { Menu } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { isTokenValid } from "../api/config";
import { FcGoogle } from "react-icons/fc";

const Sidebar = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [lang, setLang] = useState(i18n.language);
 const token  = JSON.parse(localStorage.getItem("cardsToken"))
  const toggleLang = () => {
    const nextLang = lang === "ar" ? "en" : "ar";
    i18n.changeLanguage(nextLang);
    setLang(nextLang);
    localStorage.setItem("lang", nextLang);

    const nextDir = nextLang === "ar" ? "rtl" : "ltr";
    document.documentElement.dir = nextDir;
    document.body.className = nextDir;
  };

  const onClick = (e) => {
    if (e.key === "logout") {
      dispatch(logout());
      return;
    }
    if (e.key === "lang") {
      toggleLang();
      return;
    }
    if(isTokenValid(token)){
      navigate(e.key);
    }else{
      navigate('/user/login');
      localStorage.removeItem("cardsToken")
    }
    
  };

  return (
    <Menu
      mode="inline"
      onClick={onClick}
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        width: "250px",
      }}
      items={[
        {
          key: "/",
          icon: <FaHome />,
          label: t("NAVBER.HOME"),
        },
        {
          key: "/addpcard",
          icon: <FaAddressCard />,
          label: t("NAVBER.PCARD"),
          children: [
            {
              key: "/addpcard",
              icon: <MdOutlineAdd />,
              label: t("NAVBER.ADDCARD"),
            },
            {
              key: "/pcards",
              icon: <FaAddressCard />,
              label: t("NAVBER.CARDS"),
            },
          ],
        },
        {
          key: "/addgcard",
          icon: <FcGoogle />,
          label: t("NAVBER.GCARD"),
          children: [
            {
              key: "/addgcard",
              icon: <MdOutlineAdd />,
              label: t("NAVBER.ADDCARD"),
            },
            {
              key: "/gcards",
              icon: <MdReviews  />,
              label: t("NAVBER.CARDS"),
            },
          ],
        },
        {
          key: "logout",
          icon: <MdLogout />,
          label: t("NAVBER.LOGOUT"),
        },
        {
          key: "lang",
          style: { marginTop: "auto",backgroundColor:"#1e90ff" ,textAlign:"center" , fontSize:20 },
          label: lang === "ar" ? "English" : "العربية",
        },
      ]}
    />
  );
};

export default Sidebar;
